export const brandprimary = "#2175d9";
export const brandhighlight = "#2789ff";
export const brandlight = "#262931";
export const brandmedium = "#1a1c21";
export const branddark = "#121317";
export const neutral1 = "#000000";
export const neutral2 = "#282d33";
export const neutral3 = "#383e47";
export const neutral4 = "#545a62";
export const neutral5 = "#6c727a";
export const neutral6 = "#838991";
export const neutral7 = "#9ba1a9";
export const neutral8 = "#bfc5cd";
export const neutral9 = "#d6dce4";
export const neutral10 = "#ffffff";
export const tertiarysuccess = "#78c54a";
export const tertiarywarning = "#ffa424";
export const tertiaryalertdim = "#d9203c";
export const tertiaryalertbright = "#ff405d";

